<template>
    <div class="flex w-full h-24">
        <div class="flex justify-start">
            <button
                v-if="notJoined"
                @click="join(id)"
                class="flex items-center justify-center w-6 h-6 mr-2 align-middle border border-gray-100 rounded-full bg-primary-200 focus:outline-none"
            >
                <svg class="w-4 h-4 fill-current text-primary-600" viewBox="0 0 24 24">
                    <path d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z" />
                </svg>
            </button>
            <router-link
                v-else
                tag="button"
                :to="{ name: 'team-settings', params: { id: id } }"
                class="flex items-center justify-center w-6 h-6 mr-2 text-gray-400 align-middle rounded-full hover:text-gray-600 focus:outline-none"
            >
                <svg class="w-6 h-6 fill-current" viewBox="0 0 24 24">
                    <path
                        d="M21.32,9.55l-1.89-.63.89-1.78A1,1,0,0,0,20.13,6L18,3.87a1,1,0,0,0-1.15-.19l-1.78.89-.63-1.89A1,1,0,0,0,13.5,2h-3a1,1,0,0,0-.95.68L8.92,4.57,7.14,3.68A1,1,0,0,0,6,3.87L3.87,6a1,1,0,0,0-.19,1.15l.89,1.78-1.89.63A1,1,0,0,0,2,10.5v3a1,1,0,0,0,.68.95l1.89.63-.89,1.78A1,1,0,0,0,3.87,18L6,20.13a1,1,0,0,0,1.15.19l1.78-.89.63,1.89a1,1,0,0,0,.95.68h3a1,1,0,0,0,.95-.68l.63-1.89,1.78.89A1,1,0,0,0,18,20.13L20.13,18a1,1,0,0,0,.19-1.15l-.89-1.78,1.89-.63A1,1,0,0,0,22,13.5v-3A1,1,0,0,0,21.32,9.55ZM20,12.78l-1.2.4A2,2,0,0,0,17.64,16l.57,1.14-1.1,1.1L16,17.64a2,2,0,0,0-2.79,1.16l-.4,1.2H11.22l-.4-1.2A2,2,0,0,0,8,17.64l-1.14.57-1.1-1.1L6.36,16A2,2,0,0,0,5.2,13.18L4,12.78V11.22l1.2-.4A2,2,0,0,0,6.36,8L5.79,6.89l1.1-1.1L8,6.36A2,2,0,0,0,10.82,5.2l.4-1.2h1.56l.4,1.2A2,2,0,0,0,16,6.36l1.14-.57,1.1,1.1L17.64,8a2,2,0,0,0,1.16,2.79l1.2.4ZM12,8a4,4,0,1,0,4,4A4,4,0,0,0,12,8Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,12,14Z"
                    />
                </svg>
            </router-link>
            <user-icon-row :users="users" />
        </div>
        <div class="flex items-center justify-end flex-grow" v-if="!notJoined">
            <router-link
                v-if="showingHistory"
                tag="button"
                :to="{ name: 'team', params: { id: id } }"
                class="flex items-center justify-center w-10 h-10 mx-3 text-gray-400 rounded-lg hover:bg-gray-200 hover:text-gray-600 focus:outline-none"
            >
                <svg class="w-6 h-6 fill-current" viewBox="0 0 24 24">
                    <path
                        d="M12.3,12.22A4.92,4.92,0,0,0,14,8.5a5,5,0,0,0-10,0,4.92,4.92,0,0,0,1.7,3.72A8,8,0,0,0,1,19.5a1,1,0,0,0,2,0,6,6,0,0,1,12,0,1,1,0,0,0,2,0A8,8,0,0,0,12.3,12.22ZM9,11.5a3,3,0,1,1,3-3A3,3,0,0,1,9,11.5Zm9.74.32A5,5,0,0,0,15,3.5a1,1,0,0,0,0,2,3,3,0,0,1,3,3,3,3,0,0,1-1.5,2.59,1,1,0,0,0-.5.84,1,1,0,0,0,.45.86l.39.26.13.07a7,7,0,0,1,4,6.38,1,1,0,0,0,2,0A9,9,0,0,0,18.74,11.82Z"
                    />
                </svg>
            </router-link>
            <div v-else class="flex">
                <router-link
                    tag="button"
                    :to="{ name: 'team-history', params: { id: id } }"
                    class="flex items-center justify-center w-10 h-10 mx-3 text-gray-400 rounded-lg hover:bg-gray-200 hover:text-gray-600 focus:outline-none"
                >
                    <svg class="w-6 h-6 fill-current" viewBox="0 0 24 24">
                        <path
                            d="M12,2A10,10,0,0,0,5.12,4.77V3a1,1,0,0,0-2,0V7.5a1,1,0,0,0,1,1H8.62a1,1,0,0,0,0-2H6.22A8,8,0,1,1,4,12a1,1,0,0,0-2,0A10,10,0,1,0,12,2Zm0,6a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h2a1,1,0,0,0,0-2H13V9A1,1,0,0,0,12,8Z"
                        />
                    </svg>
                </router-link>
                <span v-if="!isNotCheckedIn" class="relative z-0 inline-flex shadow-sm rounded-md">
                    <button
                        @click="$store.dispatch('flows/checkout', id)"
                        type="button"
                        class="relative inline-flex items-center px-4 py-2 rounded-l-md border border-primary-300 bg-primary-500 text-sm leading-5 font-medium text-white hover:bg-indigo-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-primary-600 transition ease-in-out duration-150"
                    >
                        Check out
                    </button>
                    <span class="-ml-px relative block">
                        <main-dropdown>
                            <template slot-scope="context">
                                <button
                                    type="button"
                                    @click="context.toggleOpen"
                                    class="relative h-10 inline-flex items-center px-2 py-2 rounded-r-md border border-primary-300 bg-primary-500 text-white text-sm leading-5 font-medium hover:bg-indigo-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-priamry-600 transition ease-in-out duration-150"
                                    aria-label="Expand"
                                >
                                    <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                        <path
                                            fill-rule="evenodd"
                                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                            clip-rule="evenodd"
                                        />
                                    </svg>
                                </button>
                                <transition
                                    enter-active-class="transition-all duration-100 ease-out"
                                    leave-active-class="transition-all duration-100 ease-in"
                                    enter-class="opacity-0"
                                    enter-to-class="opacity-100"
                                    leave-class="opacity-100"
                                    leave-to-class="opacity-0"
                                >
                                    <div
                                        v-if="context.open"
                                        class="absolute right-0 z-20 w-64 mt-1 overflow-hidden origin-top-right bg-white border border-gray-200 rounded-md shadow-md"
                                    >
                                        <button
                                            type="button"
                                            @click="$store.dispatch('flows/checkoutAndStartWithTasks', id)"
                                            class="group flex text-left items-center px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                                            role="menuitem"
                                        >
                                            <svg
                                                class="mr-3 h-6 w-6 text-gray-400 group-hover:text-primary-500 group-focus:text-primary-500"
                                                viewBox="0 0 20 20"
                                                fill="currentColor"
                                            >
                                                <path
                                                    fill-rule="evenodd"
                                                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z"
                                                    clip-rule="evenodd"
                                                />
                                            </svg>
                                            Start check-in with open tasks
                                        </button>
                                    </div>
                                </transition>
                            </template>
                        </main-dropdown>
                    </span>
                </span>
            </div>
        </div>
    </div>
</template>
<script>
import UserIconRow from '@/components/UserIconRow';
import MainDropdown from '@/components/MainDropdown';

export default {
    name: 'team-content-header',
    components: { UserIconRow, MainDropdown },
    props: {
        users: Array,
        id: Number,
    },
    methods: {
        join(id) {
            this.$store.dispatch('teams/join', id);
        },
    },
    computed: {
        notJoined() {
            return this.users.find(user => user.id === this.$store.state.users.user.id) === undefined;
        },
        showingHistory() {
            return this.$route.name === 'team-history';
        },
        isNotCheckedIn() {
            return (
                this.$store.state.flows.all.filter(flow => flow.user_id === this.$store.state.users.user.id && flow.completed === false && flow.team_id === this.id).length === 0
            );
        },
    },
};
</script>
